module.exports = __webpack_public_path__ + "img/ligue-contre-le-cancer.86317c96.jpg";